<template>
    <div class="topbar_left" :class="[isDesktop.screenSize.value === 'xs' ? 'gap-2' : 'gap-4']">
        <slot></slot>
    </div>
</template>

<script setup>
import { useScreenSize } from "@/composables/globals";
const isDesktop = useScreenSize();
</script>

<style scoped>
.topbar_left {
    @apply flex items-center lg:w-auto sm:w-[calc(100%-150px)] lg:flex-nowrap sm:flex-wrap;
}
.topbar_left:empty {
    @apply w-0;
}
</style>
